/*
 *
 *  *
 *  *  * The Initial Developer of the content of this file is NETCONOMY.
 *  *  * All portions of the code written by NETCONOMY are property of NETCONOMY. All Rights Reserved.
 *  *  *
 *  *  * NETCONOMY Software & Consulting GmbH
 *  *  * Hilmgasse 4, A-8010 Graz (Austria)
 *  *  * FN 204360 f, Landesgericht fuer ZRS Graz
 *  *  * Tel: +43 (316) 815 544
 *  *  * Fax: +43 (316) 815544-99
 *  *  * www.netconomy.net
 *  *  *
 *  *  * (c) 2016 by NETCONOMY Software & Consulting GmbH
 *  *  *
 *
 */

import logger from './rbata.logger';
import urlUtils from '../services/rbata.urlService';

const recaptcha = {
    siteKeyInvisible: ACC.recaptcha.invisible,
    siteKeyHuman:     ACC.recaptcha.human, // not used atm
    recaptchaWidget:  undefined,
    callbackMethod:   undefined,
    TYPE_INVISIBLE:   'invisible',
    TYPE_NORMAL:      'normal',
    template:         '<div id="recaptcha" class="mb-3"></div>',

    /**
     * Receives callback method which is executed when recaptcha chekc is done and it will return token
     * @param callback
     * @param size
     * @param container
     */
    init(callback, size = recaptcha.TYPE_NORMAL, container = $('body')) {
        recaptcha.callbackMethod = callback;
        container.prepend(recaptcha.template);

        window.recaptchaCallback = function () {
            recaptcha.render(size);
        }

        const script = document.createElement('script');
        script.type  = "text/javascript";
        script.async = true;
        script.defer = true;
        script.src   = "https://www.google.com/recaptcha/api.js?onload=recaptchaCallback&render=explicit";
        if (!alphatauri.cookie.considerConsent || alphatauri.cookie.optanonConsentGiven) {
            document.body.append(script);
        }
    },

    render(size) {
        logger.log('reCAPTCHA render call');
        const container  = document.querySelector('#recaptcha');
        const parameters = {
            sitekey:  recaptcha.siteKeyInvisible,
            size:     size,
            callback: recaptcha.onSubmit
        };

        recaptcha.recaptchaWidget = grecaptcha.render(
                container,
                parameters
        );
    },

    verifyResult(token) {
        return $.ajax({
            url:    `${urlUtils.getBaseUrl()}contactRecaptcha?token=${token}`,
            method: 'POST'
        });
    },

    execute() {
        //Use only with invisible
        return grecaptcha.execute(recaptcha.recaptchaWidget);
    },

    onSubmit(token) {
        recaptcha.callbackMethod(token);
    },

    getResult() {
        return grecaptcha.getResponse(
                recaptcha.recaptchaWidget
        )
    },

    isReady() {
        if (!!this.siteKeyInvisible && !!this.siteKeyHuman) {
            return true;
        } else {
            logger.log('reCAPTCHA: No site keys defined. Please define keys for human and invisible reCAPTCHA');
            return false;
        }
    }
}

export default recaptcha;